import React, { ComponentProps } from 'react';
import { css } from 'aphrodite/no-important';
import { useIntl } from 'react-intl';
import JourneyLiveTracker from '@trainline-shareable/journey-live-tracker';
import { useSelector } from 'react-redux';
import { SegmentedButton } from '@trainline/depot-web';

import { orderDetailsSelector } from '../OrderDetails/selectors';
import { useItineraryViews } from '../../hooks/useItineraryViews';
import useJourneyDirection, { Direction } from '../../hooks/useJourneyDirection';
import messages from '../../messages';

import styles from './styles';

type Props = ComponentProps<typeof JourneyLiveTracker>;
type Locale = Props['locale'];

const Journey = () => {
  const { currentLocale, order } = useSelector(orderDetailsSelector);
  const { itinerary } = useItineraryViews(order.orderReference);
  const { formatMessage } = useIntl();

  const journeys = [
    itinerary.outwardJourney,
    ...(itinerary.inboundJourney ? [itinerary.inboundJourney] : []),
  ];
  const { selectedJourney, hasInbound, journeyDirection, handleDirectionChange } =
    useJourneyDirection(journeys);

  return (
    <div className={css(styles.container)}>
      <div className={css(styles.twoColumns)}>
        <div className={css(styles.column)}>
          {/* Heading here */}

          {hasInbound && (
            <SegmentedButton
              type="standard"
              segments={[
                {
                  id: 'journey-outbound',
                  label: formatMessage({ ...messages.outboundButton }),
                  checked: journeyDirection === Direction.OUTBOUND,
                  value: Direction.OUTBOUND,
                  onChange: () => handleDirectionChange(Direction.OUTBOUND),
                },
                {
                  id: 'journey-inbound',
                  label: formatMessage({ ...messages.inboundButton }),
                  checked: journeyDirection === Direction.INBOUND,
                  value: Direction.INBOUND,
                  onChange: () => handleDirectionChange(Direction.INBOUND),
                },
              ]}
              className={css(styles.journeyDirection)}
            />
          )}

          <JourneyLiveTracker
            locale={currentLocale as unknown as Locale}
            journey={selectedJourney}
            displayOptions={{
              cardStyleLegs: true,
              displayTimetableIds: true,
              displaySeatReservations: true,
            }}
          />
        </div>
        <div className={css(styles.column)}>
          {/* Placeholder for Passengers block */}
          <div className={css(styles.spacer)}>
            <h3>Passengers</h3>
            <div className={css(styles.cardsLayout)} />
          </div>
          {/* Placeholder for Carrier Reservations and Tickets block */}
          <div className={css(styles.spacer)}>
            <h3>Carrier Reservations and Tickets</h3>
            <div className={css(styles.cardsLayout)} />
          </div>
        </div>
      </div>
    </div>
  );
};
export default Journey;
